import { render, staticRenderFns } from "./ShareThree.vue?vue&type=template&id=5cf533fc&scoped=true"
import script from "./ShareThree.vue?vue&type=script&lang=js"
export * from "./ShareThree.vue?vue&type=script&lang=js"
import style0 from "./ShareThree.vue?vue&type=style&index=0&id=5cf533fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf533fc",
  null
  
)

export default component.exports